import { configureStore } from '@reduxjs/toolkit';
import localizationSlice from './slices/localizationSlice';
import authSlice from './slices/authSlice';
import notificationSlice from './slices/notificationSlice';
import ModalSlice from './slices/modalSlice';
import confirmSlice from './slices/confirmSlice';

const store = configureStore({
  reducer: {
    localizations: localizationSlice,
    modal: ModalSlice,
    notifications: notificationSlice,
    confirm: confirmSlice,
    auth: authSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'notifications/add',
          'modal/open',
          'confirm/showConfirm'
        ],
        ignoredPaths: [
          'notifications.items',
          'modal.content',
          'modal.callback',
          'modal.options.onClose',
          'confirm.header',
          'confirm.body',
          'confirm.message',
          'confirm.okValue',
          'confirm.cancelValue',
          'confirm.onConfirm'
        ]
      },
      immutableCheck: {
        ignoredPaths: ['notifications.items', 'modal.content', 'confirm.body']
      }
    }),
  devTools: process.env.NODE_ENV !== 'production'
});

export default store;
